import { render } from "./ZebraPrintView.vue?vue&type=template&id=00567c35&ts=true"
import script from "./ZebraPrintView.vue?vue&type=script&lang=ts"
export * from "./ZebraPrintView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__